export default {
  logoDescription: 'Selecione um ficheiro (.JPG ou .GIF) com o logotipo da sua empresa para ser incluído na visualização das faturas que emita. A imagem do ficheiro não pode exceder 200 pixels de largura por 200 pixels de altura.',
  ownerDescription: 'Se desejar, pode selecionar um ficheiro XSLT de transformação do formato proprietário da UBL 1.0. Também pode atribuir um nome ao ficheiro de origem.',
  ownerFile: 'Ficheiro XSLT',
  inputDescription: 'Nome do ficheiro',
  logoLabel: 'Logotipo',
  pdfConfg: 'Selecione uma das modelos para a visualização em PDF das faturas. As faturas que forem emitidas a partir de agora serão associadas a este modelo.',
  template: 'Modelo',
  seeExample: 'Ver Exemplo de Fatura em PDF',
  formatDescription: 'Selecione um dos seguintes formatos para o recebimento de faturas assinadas. Se escolher o valor "Formato Entrante", irá receber as faturas assinadas no formato utilizado pelo emissor.',
  format: 'Formato',
  logoFormats: '{0}: JPG, GIF',
  titles: {
    first: 'Seleção do formato em que deseja receber as faturas',
    second: 'Configuração do modelo de PDF para visualização das faturas',
    third: 'Configuração do logotipo na visualização das faturas',
    fourth: 'Configuração de formato proprietário para poder importar faturas na plataforma'
  },
  billFormat: {
    text: '{0}: 200 pixels de altura por 200 pixels de largura',
    label: 'Dimensões',
    file: '{0}: XSLT'
  }
}